<template>
  <div class="flow-container">
		<flowleft></flowleft>
		<flowmain v-show="curFlowId" :key="curFlowId" @debugger="openDebugger"></flowmain>
  </div>
</template>
<script>
import flowleft from './components/FlowLeft'
import flowmain from './components/FlowMain'
import { mapMutations, mapState, mapActions } from 'vuex'
import { getToken } from '@/utils/auth'

export default {
  components: {
		flowleft,
		flowmain
  },
  computed: {
    ...mapState('flow', [
			'curFlowId'
    ]),
    ...mapState('scene', [
			'scene'
    ]),
  },
}
</script>
<style lang="scss" scoped>
.flow-container {
  height: calc(100vh - 50px);
  display: flex;
  justify-content: flex-start;
  .flow-left {
    width: 200px;
  }
}
</style>